import React from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import HomePage from "./components/HomePage";
import LandingPage from "./components/LandingPage";
import QuickDrawPage from "./components/QuickDrawPage";

function App() {
  const navigate = useNavigate();
  const handleStartGame = (theme) => {
    navigate("/game");
  };

  return (
    <Routes>
      <Route path="/" element={<HomePage onStartGame={handleStartGame} />} />
      <Route path="/game" element={<LandingPage />} />
      <Route path="/quickdraw" element={<QuickDrawPage />} />
    </Routes>
  );
}

export default App;